/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const ErrorWrap = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${Palette.Red._500};
    margin-left: 8px;
  }
`;

export const GeneralContainer = styled.div`
  display: flex;
  border-radius: 4px;
  gap: 16px;
  border: ${({ showBorder }) => showBorder && `1px solid ${Palette.Red._300}`};
`;
